import React, { useRef } from 'react';
import ReactPlayer from 'react-player';

interface IFullscreenPlayer {
    videoUrl?: string;
    imageUrl?: string;
}

interface CustomHTMLVideoElement extends HTMLVideoElement {
    webkitRequestFullscreen?: () => void;
    msRequestFullscreen?: () => void;
}

const FullscreenPlayer = ({ videoUrl, imageUrl }: IFullscreenPlayer) => {
    const playerRef = useRef<ReactPlayer>(null);
    const containerRef = useRef<HTMLDivElement>(null);

    const handlePlay = () => {
        const container = containerRef.current as unknown as HTMLElement &
            CustomHTMLVideoElement;

        if (container) {
            if (container.requestFullscreen) {
                container.requestFullscreen();
            } else if (container.webkitRequestFullscreen) {
                container.webkitRequestFullscreen(); // Safari
            } else if (container.msRequestFullscreen) {
                container.msRequestFullscreen(); // IE/Edge
            }
        }
    };

    const handleExitFullscreen = () => {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        }
    };

    return (
        <div
            ref={containerRef}
            style={{ position: 'relative', width: '100%', height: '100%' }}
        >
            <ReactPlayer
                ref={playerRef}
                url={videoUrl}
                light={<img src={imageUrl} alt="Thumbnail" />}
                playing={false}
                controls={true}
                width="100%"
                height="100%"
                onPlay={handlePlay}
                onClickPreview={handlePlay}
                onEnded={handleExitFullscreen}
                config={{
                    file: {
                        attributes: {
                            controlsList: 'nodownload', // Prevent download
                            disablePictureInPicture: true, // Disable picture-in-picture
                        },
                    },
                }}
            />
        </div>
    );
};

export default FullscreenPlayer;
